export const isDate = input => {
	return Object.prototype.toString.call(input) === '[object Date]' && !Number.isNaN(input.getTime())
}

export const formatDate = (date, order = null, delimiter = '/') => {
	const nDate = new Date(date)
	if (!isDate(nDate)) return ''
	var d = nDate.getDate()
	var m = nDate.getMonth() + 1
	var y = nDate.getFullYear()
	const dayString = `${d < 10 ? `0${d}` : `${d}`}`
	const monthString = `${m < 10 ? '0' + m : m}`
	const mappedOrder = { day: dayString, month: monthString, year: y }
	let formattedDate = `${dayString}${delimiter}${monthString}${delimiter}${y}`
	if (order) {
		formattedDate = order.reduce((accum, val, i) => {
			const dateVal = mappedOrder[val]
			if (dateVal) {
				accum += `${dateVal}${i < order.length - 1 ? delimiter : ''}`
			}
			return accum
		}, '')
	}
	return formattedDate
}
export const trimTimeStr = (date, str) => {
	if (str.toLowerCase() === '0 am') {
		/*
		 * 	if it's the AM
		 *	mark new date
		 */
		return new Date(date).toLocaleDateString([], {
			month: 'short',
			day: 'numeric',
		})
	}

	if (str.includes('0:')) {
		str = str.replace(/^(0:)/, '12:')
	} else if (str === '0 pm') {
		str = str.replace(/^(0)/, '12')
	}

	return str
}
export default function useDateTime() {
	const today = new Date()
	const splitMyTime = timeStr => {
		let [hr, min] = timeStr.split(':')
		const add12 = min.includes('am') ? 0 : 12
		min = min.replace(/\s(am|pm)/, '')
		hr = Number(hr) + add12
		return [Number(hr), Number(min)]
	}

	const addDays = days => {
		var date = new Date(Date.now().valueOf())
		date.setDate(date.getDate() + days)
		return new Date(date)
	}
	const minusDays = days => {
		var date = new Date(Date.now().valueOf())
		date.setDate(date.getDate() - days)
		return new Date(date)
	}
	const addDaysFrom = (date, days) => {
		const daysLater = date.getDate() + days
		return new Date(date.setDate(daysLater))
	}
	// const diffDays
	const diffDates = (date1, date2) => {
		const d1 = new Date(date1).getTime()
		const d2 = new Date(date2).getTime()
		//milliseconds
		const diffTime = Math.abs(date2 - date1)
		//days
		const diffDays = Math.ceil((d2 - d1) / (1000 * 60 * 60 * 24))
		//months
		const diffMonths = Math.ceil((d2 - d1) / (1000 * 60 * 60 * 24 * 30))
		//past or future
		// const
		return {
			diffTime,
			diffDays,
			diffMonths,
		}
	}

	const updateTime24 = time => (time > 23 ? 23 : time)
	const setTimeIntervals = (range = 24, interval = 30) => {
		var times = []
		var hours = 24 - range
		for (hours; hours < 24; hours++) {
			for (var mins = 0; mins < 60; mins += interval) {
				times = [...times, `${hours < 10 ? '0' : ''}${hours}:${mins === 0 ? 0 : ''}${mins}`]
			}
		}
		return times
	}
	const dateFromDMY = (str, limiter = '/') => {
		const [d, m, y] = str.split(limiter)
		return new Date(y, m - 1, d)
	}
	/* add hours to formatted string ( replace colons with . ) */
	const addHoursToTimeString = (timeString, hours) => {
		const timeSplit = timeString.split(':')
		const hrs = parseInt(timeSplit[0], 10) + hours
		const mins = parseInt(timeSplit[1], 10)
		const result = `${hrs}:${mins > 0 ? mins : mins + '0'}`
		return result
	}
	/* add hours in miliseconds */
	const hrsToMilliseconds = hours => hours * 3600000
	const minsToMilliseconds = mins => mins * 60000
	/* create new date object with more hours */
	const addHours = (date, hours) =>
		!isDate(date) ? new Date(date) + hrsToMilliseconds(hours) : new Date(date.getTime() + hrsToMilliseconds(hours))
	/* days are same */
	const daysAreSame = (a, b) => a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getYear() === b.getYear()
	/* isToday */
	const isToday = date => daysAreSame(date, today)
	/* format time  */
	const formatTime = (date, withSeconds = true) => {
		var d = new Date(date)
		var hours = d.getHours()
		var minutes = d.getMinutes()
		var seconds = d.getSeconds()
		var formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}${
			withSeconds ? ':' + (seconds < 10 ? '0' + String(seconds) : String(seconds)) : ''
		}`
		return formattedTime
	}

	const addMinutesToDate = (date, minutes) =>
		!isDate(date) ? new Date(date) + minsToMilliseconds(minutes) : new Date(date.getTime() + minsToMilliseconds(minutes))

	/* remove pesky colons */
	const removeColons = str => str.replace(/[:]/gi, '')
	/* get the next inteval along */
	const addInterval = (time, interval = 30) => {
		const times = setTimeIntervals(interval)
		const match = setTimeStrToInterval(time)
		return times.reduce((acumm, val, i, arr) => {
			if (match === val) {
				acumm = arr[i + 1]
			}
			return acumm
		}, '12:30')
	}
	/* Create a time string based on an interval */
	const setTimeStrToInterval = (str, interval = 30) => {
		const sub = removeColons(str)
		let hours = Number(sub.slice(0, 2))
		let mins = Number(sub.slice(2))

		if (mins > interval) {
			hours += 1
			mins = '00'
		} else if (mins < interval) {
			mins = '30'
		}
		if (hours < 10) {
			hours = `0${hours}`
		}
		const result = `${hours}:${mins}`
		return result
	}

	return {
		addDays,
		addDaysFrom,
		addMinutesToDate,
		diffDates,
		updateTime24,
		setTimeIntervals,
		dateFromDMY,
		addHoursToTimeString,
		hrsToMilliseconds,
		addHours,
		daysAreSame,
		isToday,
		formatTime,
		formatDate,
		isDate,
		removeColons,
		trimTimeStr,
		addInterval,
		minusDays,
		setTimeStrToInterval,
		splitMyTime,
	}
}
